import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function JetMediaShuttleWorkflowReceiving() {
    return (
        <React.Fragment>
            <p>
                <strong>Note</strong>: Transferring a large data set in Media Shuttle generates{' '}
                <code className="language-text">#work_file#</code> and{' '}
                <code className="language-text">#chkpt_file#</code> temporary files while transferring to storage. Hot
                folder jobs may transfer these files during a Media Shuttle upload. Once all transfers are complete,
                these files can be safely deleted on the receiving endpoint.
            </p>
        </React.Fragment>
    );
}

JetMediaShuttleWorkflowReceiving.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(JetMediaShuttleWorkflowReceiving);
